module.exports = __webpack_public_path__ + "static/media/number_scale_rating.f5ca5145.svg";